// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';

const RightSide = styled(Col).attrs({
    xs: 12,
    lg: 3,
    className: 'pb-lg-5'
})`
    margin-top: -46px;

    @media all and (max-width: 992px) {
        margin-top: unset;
    }
`;

const RightSideContainer = ({ children }) => {
    return <RightSide>{children}</RightSide>;
};

export default RightSideContainer;
